// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3-8UG","picS":"_1NJLS","picM":"_1UBLO","textBox":"_1Xaea"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Special/Avdelare/Avdelare.scss
 ** module id = 444
 ** module chunks = 0
 **/